import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ParametrosService } from 'src/app/services/parametros.service';
import type {
  HomeDatosContent,
  HomeDatosEstadisticasResponse,
} from '../models/home-datos-content.model';
import {
  buildHomeDatosFallback,
  mapEstadisticasToHomeDatos,
} from '../utils/home-datos-metrics.mapper';

@Injectable({
  providedIn: 'root',
})
export class HomeDatosService {
  private readonly fallbackContent: HomeDatosContent = buildHomeDatosFallback();

  constructor(private readonly parametrosService: ParametrosService) {}

  loadContent(): Observable<HomeDatosContent> {
    return this.parametrosService.getIndicadores().pipe(
      map((response: HomeDatosEstadisticasResponse) =>
        mapEstadisticasToHomeDatos(response, this.fallbackContent)
      ),
      catchError(() => of({ ...this.fallbackContent }))
    );
  }
}
